/*
SaiKrishna 10/06/2022 2700520533 Removed unnecessary console.log statements
SaiKrishna 11/10/2022 3225733165 Added redux state required for state management of work queue
Ashraf 12/23/2022 2700524332 handling error response
Sohel 09/26/2023 2700524332 Company lookup data change and integerated
*/
import { createSlice } from '@reduxjs/toolkit';
import { httpPost } from '../../util/Rest';
// import {httpGet, httpPost} from '../../util/Rest';

const initialData = {
  roleData: {},
  isLoading: false,
  errorMsg: null,
  successMsg: null,
  userId: '',
  showDashboardWorkQueue: false,
};

const slice = createSlice({
  name: 'role',
  initialState: {
    ...initialData,
  },
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
    },
    getRoleData: (state, action) => {
      state.roleData = action.payload;
      sessionStorage.setItem('isLoading', false);
      state.isLoading = false;
      state.errorMsg = null;
    },
    getUserId: (state, action) => {
      state.userId = action.payload['userDetails'].userId;
    },
    setShowDashboardWorkQueue: (state, action) => {
      state.showDashboardWorkQueue = action?.payload;
    },
    fetchError: (state, action) => {
      state.errorMsg = action?.payload?.data?.error ? action.payload.data.error : action.payload;
      state.isLoading = false;
      sessionStorage.setItem('isLoading', false);
    },
    resetRole: (state) => {
      state.roleData = {};
    },
  },
});

export default slice.reducer;

// Actions
export const {
  getRoleData,
  fetchStart,
  fetchError,
  resetRole,
  getUserId,
  setShowDashboardWorkQueue,
} = slice.actions;
export const fetchRole = (details) => {
  const rolesData = JSON.parse(sessionStorage.getItem('userRoles'));
  const userRole = JSON.parse(sessionStorage.getItem('userDetails'));
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`user/ui/functions`, {
      roleName: details
        ? details
        : userRole?.role
          ? [userRole?.role]
          : rolesData?.userRoles?.length
            ? [rolesData?.userRoles[0]]
            : [],
    })
      // httpGet(`user/ui/functions?roleName=${details ? details : userRole?.role ? userRole?.role : rolesData?.userRoles?.length ? rolesData?.userRoles[0] : ''}`)
      .then((data) => {
        if (data && data.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(getRoleData(data.response));
          dispatch(getUserId(data.response));
          sessionStorage.setItem(
            'userRoles',
            JSON.stringify({ userRoles: data?.response?.userDetails?.roles }),
          );
          sessionStorage.setItem('userDetails', JSON.stringify(data?.response?.userDetails));
          sessionStorage.setItem(
            'companyName',
            JSON.stringify(data?.response?.userDetails?.companyName),
          );
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};
export const resetRoleData = () => {
  return (dispatch) => {
    dispatch(resetRole());
  };
};

export const selectShowDashboardWorkQueue = (state) => state.role.showDashboardWorkQueue;
